import { TransactionType, TransFields, Cols, ITransaction, ICompValue2, IValue } from "../shared/Consts"
import Utils from "../portlibs/PortUtils";
import Holding from "./Holding";
import { GICTransaction } from "./GICTransaction";
import { BondTransaction } from "./BondTransaction";
import { ITransRow } from "../shared/ITransaction";

export class Transaction implements ITransRow, ITransaction, ICompValue2, IValue {
    json:ITransRow

    _id:string
    type: TransactionType;
    date: Date;
    quantity: number;
    price: number;
    accountId: number;
    note: string;
    holding:Holding;
    yield:number
    maturity: Date
    gain:number

    get u() { return this.json.u }
    get i() { return this.json.i }
    get t() { return this.json.t }
    get d() { return this.json.d }
    get q() { return this.json.q }
    get a() { return this.json.a }
    get p() { return this.json.p }
    get n() { return this.json.n }
    get y() { return this.json.y }
    get m() { return this.json.m }
    
    constructor(holding:Holding, json:any){
        this._id = json._id || ""
        this.holding = holding;
        if (json instanceof Transaction){
            // from clone
            this.json = json.json
            this.type = json.type
            this.date = json.date
            this.quantity = json.quantity
            this.price = json.price
            this.accountId = json.accountId
            this.note = json.note;
            this.maturity = json.maturity
            this.yield = json.yield
            this.gain = json.gain
        }else{
            this.json = json
            this.type = json[TransFields.type]
            this.date = new Date(json[TransFields.date] + " 00:00:00");
            this.quantity = json[TransFields.quantity] || 0;
            this.price = json[TransFields.price] || 0;
            this.accountId = json[TransFields.account] || 0;
            this.note = json[TransFields.note] || "";
            this.gain = 0;

            if (json[TransFields.maturity]) this.maturity = new Date(json[TransFields.maturity]+" 00:00:00");
            else {
                let date = new Date(this.date);
                this.maturity = new Date(date.setFullYear(date.getFullYear()+1));
            }
            this.yield = json[TransFields.yield] || 0;
        }
    }

    get id(){return this._id}
    get isBuy(){return this.type==TransactionType.buy && this.quantity>0}
    get isSell(){return this.type==TransactionType.buy && this.quantity<0}
    get isReinvest(){return this.type==TransactionType.reinvest || this.type==TransactionType.topup}
    get isDividend(){return this.type==TransactionType.dividend || this.type==TransactionType.interest}
    get isBuyOrSell(){return this.type==TransactionType.buy || this.isReinvest}
    get isInterest(){return this.type==TransactionType.interest}
    get isAdjust(){return this.type==TransactionType.adjust}
    
    static isGIC(trans:Transaction) : trans is GICTransaction {
        return trans.holding.isGIC_or_bond
    }
    static isBOND(trans:Transaction) : trans is BondTransaction {
        return trans.holding.isBond
    }
    
    clone():Transaction {
        return new Transaction(this.holding, this)
    }
    value(col:string) : string {
        switch(col){
        case Cols.quantity:     return Utils.formatNumber(this.quantity)
        case Cols.price:        return Utils.formatCurrency(this.holding.currency, this.price);
        case Cols.date:         return Utils.formatDate("yyyy-MM-dd", this.date);
        case Cols.accountId:    return this.holding.portfolio.accountName(this.accountId);
        case Cols.total:        return Utils.formatCurrency(this.holding.currency, Math.abs(this.price*this.quantity));
        case Cols.type:         return this.actionName;
        case Cols.note:         return this.note || "";
        case Cols.maturity:     return Utils.formatDate("yyyy-MM-dd", this.maturity);
        case Cols.yield:        return Utils.formatNumber(this.yield) + "%";
        case Cols.gain:         return Utils.formatCurrency(this.holding.currency, this.gain)
        default:                return this.holding.value(col)
        }
    }
    rawValue(col:string) : string|number {
        switch(col){
        case Cols.accountId:    return this.holding.portfolio.accountName(this.accountId);
        case Cols.date:         return Utils.formatDate("yyyy-MM-dd", this.date)
        case Cols.total:        return this.price*this.quantity;
        case Cols.type:         return this.actionName
        case Cols.price:        return this.price;
        case Cols.note:         return this.note;
        case Cols.quantity:     return this.quantity;
        default:                return this.holding.rawValue(col)
        }
    }
    compValue(col:string) : number|string {
        if (col==Cols.name) return this.holding.compValue(col)
        else if (col==Cols.date) return this.date.getTime()
        else if (col==Cols.type) return this.actionName
        else if (col==Cols.total) return this.rawValue(col)
        return (this as any)[col]
    }
    get actionName() : string {
        switch(this.type){
        case TransactionType.buy:       return this.isBuy ? "Buy" : "Sell"
        case TransactionType.reinvest:  return "Reinvest";
        case TransactionType.topup:     return "Top-up";
        case TransactionType.adjust:    return "Adjust";
        case TransactionType.dividend:  return "Dividend";
        case TransactionType.interest:  return "Interest";
        default:                        return "-"
        }
    }
    addActionClass(klass:string[]) {
        switch(this.type){
        case TransactionType.buy:       klass.push(this.quantity>0?"red":"teal"); break;
        case TransactionType.dividend:
        case TransactionType.interest:  klass.push("green"); break;
        case TransactionType.reinvest:
        case TransactionType.topup:     klass.push("orange"); break;
        }
    }
    className(col:string) : string {
        let ret = [this.holding.className(col)]
        switch(col){
        case Cols.date:
        case Cols.maturity:     return "no-break";
        case Cols.type:
        case Cols.total:
            this.addActionClass(ret);
            break;
        }
        return ret.join(" ");        
    }
    get payload(){
        const ret:any = {
            _id:this._id,
            account:this.accountId,
            type:this.type,
            qty:this.quantity,
            price:this.price,
            note:this.note,
            date:Utils.formatDate("yyyy-MM-dd", this.date)
        }
        return ret;
    }
    filter(search:string) : boolean {
        return this.note.toLowerCase().indexOf(search)>=0 || this.holding.shouldFilter(search)
    }
}
